import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

export default function Reviews() {
  return (
    <div className="min-h-screen py-24 bg-cream flex items-center justify-center">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Star size={80} className="text-turmeric mx-auto mb-8" />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold text-brown-dark mb-6">
            Customer Reviews
          </h1>
          <div className="bg-leaf/10 border-2 border-dashed border-leaf rounded-2xl p-12">
            <p className="text-3xl font-caveat text-brown-dark mb-4">
              Your Feedback Matters!
            </p>
            <p className="text-6xl font-playfair font-bold text-spice mb-6">
              Coming Soon!
            </p>
            <p className="text-lg text-brown-medium">
              We're gathering amazing reviews from our happy customers. Check back soon to see what people are saying about our gourmet chaat!
            </p>
          </div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="mt-8"
          >
            <a
              href="/menu"
              className="inline-block bg-spice text-white px-8 py-3 rounded-full hover:bg-spice-hover transition-all transform hover:-translate-y-1 font-bold"
              data-testid="order-now-btn"
            >
              Try Our Chaat
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}